{
  "defaultEntitySelectLabel": "Nom",
  "defaultRelationSelectLabel": "Relation"
}
